import type { ProductConfig, ProductContext } from "../product-types";

/** Decorative layer class strings (kept literal so Tailwind can see them). */
export const DECO = {
  grid20: "pointer-events-none absolute inset-0 -z-10 bg-grid opacity-20",
  grid25: "pointer-events-none absolute inset-0 -z-10 bg-grid opacity-25",
  grid30: "pointer-events-none absolute inset-0 -z-10 bg-grid opacity-30",
  grid40: "pointer-events-none absolute inset-0 -z-10 bg-grid opacity-40",
  heroAurora: "pointer-events-none absolute inset-0 -z-10 opacity-70",
  remotePrimaryBlob:
    "pointer-events-none absolute -right-32 -top-32 -z-10 h-[24rem] w-[24rem] rounded-full opacity-20 blur-3xl bg-primary",
  remoteAuroraBlob:
    "pointer-events-none absolute -top-32 -right-32 -z-10 h-[28rem] w-[28rem] rounded-full opacity-40 blur-3xl",
} as const;

/** Aurora-glow-behind-media class strings. */
export const AURORA = {
  heroImage: "pointer-events-none absolute -inset-10 -z-10 rounded-[2rem] opacity-70 blur-3xl",
  perfReveal: "pointer-events-none absolute -inset-10 -z-10 rounded-[2rem] opacity-60 blur-3xl",
  softwareImage: "pointer-events-none absolute -inset-8 -z-10 opacity-50 blur-3xl",
  remoteImage: "pointer-events-none absolute -inset-10 -z-10 rounded-[2rem] opacity-60 blur-3xl",
} as const;

export function breadcrumb(ctx: ProductContext, productName: string): ProductConfig["breadcrumb"] {
  const m = ctx.messages;
  return {
    ariaLabel: m.breadcrumbLabel,
    homeHref: ctx.urls.home,
    homeLabel: m.tv6UltraBreadcrumbHome,
    productsHref: ctx.urls.products,
    productsLabel: m.tv6UltraBreadcrumbProducts,
    productName,
  };
}
